import React, { createContext, useState, useEffect } from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { useServerData } from '../../state/serverDataContext';

const LoadingPlaceholder = () => <></>;

const BannerUK = loadable(() => import(/* webpackChunkName: 'BannerUK' */ './locales/BannerUK'), { fallback: <></> });
const BannerES = loadable(() => import(/* webpackChunkName: 'BannerES' */ './locales/BannerES'), { fallback: <></> });

export const BannerPropTypes = {
  sliderData: PropTypes.arrayOf(PropTypes.object).isRequired,
  isMobile: PropTypes.bool.isRequired,
  interval: PropTypes.number,
};

export const LocaleContext = createContext({ dataJurisdiction: '' });

const withLoadingPlaceholder = (Component, Placeholder) => {
  return function WithLoadingPlaceholder(props) {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
      setLoaded(true);
    }, []);

    return loaded ? <Component {...props} /> : <Placeholder />;
  };
};

const Banner = () => {
  const { sliderData, locale, isMobile } = useServerData(data => ({
    sliderData: data.pageData?.sliderData || [],
    locale: data.locale,
    isMobile: data.isMobile || false,
  }));

  const LoadableBannerUK = withLoadingPlaceholder(BannerUK, LoadingPlaceholder);
  const LoadableBannerES = withLoadingPlaceholder(BannerES, LoadingPlaceholder);

  const LocaleBanner = locale === 'es-es' ? LoadableBannerES : LoadableBannerUK;

  const withoutStepsWrapper = ['en-uk', 'en-ir', 'es-es'];
  const bannerProps = {
    sliderData,
    isMobile,
    ...(withoutStepsWrapper.includes(locale) && {
      hasStepsWrapper: false,
    }),
  };

  return (
    <LocaleContext.Provider value={{ dataJurisdiction: locale }}>
      <LocaleBanner {...bannerProps} />
    </LocaleContext.Provider>
  );
};

export default Banner;
